import api from "../../Http/global-vars";
import { FETCH_SHOW_OF, FETCH_SHOW_OF_FRONT } from "../types";

export const fetchShowOf = () => {
  return async (dispatch: (arg0: { type: string; payload: any }) => void) => {
    const config = {
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("userToken")}`,
      },
    };
    const token = window.localStorage.getItem("userToken");

    const url = api + "showof/";

    if (token) {
      await fetch(url, config)
        .then(async (res) => {
          const data = await res.json();
          dispatch({
            type: FETCH_SHOW_OF,
            payload: data.results,
            // ,
          });
        })
        .catch((error) => console.log("error", error?.response));
    }
  };
};

export const fetchShowOfFront = () => {
  return async (dispatch: (arg0: { type: string; payload: any }) => void) => {
    const url = api + "showoffront/";

    await fetch(url)
      .then(async (res) => {
        const data = await res.json();
        // console.log("response data showof",data);
        dispatch({
          type: FETCH_SHOW_OF_FRONT,
          payload: data.results,
        });
      })
      .catch((error) => console.log("error", error?.response));
  };
};
